import * as Yup from "yup";

export const welcomeValidationSchema = Yup.object({
  phoneNumber: Yup.string()
    .required("Phone number is required")
    .matches(/^\d*$/, "Enter only number")
    .length(12, "Enter a valid phone number"),
  age: Yup.string()
    .required("Date of Birth is required")
    .test(
      "is-old-enough",
      "You must be at least 18 years old",
      function (value) {
        if (!value) return false;
        const dob = new Date(value);
        if (isNaN(dob.getTime())) return false;

        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();

        const m = today.getMonth() - dob.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
          age--;
        }

        return age >= 18;
      }
    ),

  gender: Yup.string().required("Geneder is required"),
  language: Yup.array()
    .required("Atleast one languages required")
    .min(1, "Atleast one languages required"),
  experience: Yup.string()
    .required("Experience is required")
    .matches(/^\d*$/, "Enter only number"),
  currencyCode: Yup.string().required("Country is required"),
  currentCTC: Yup.string().required("Current CTC required"),
  expectedCTC: Yup.string().required("Expected CTC required"),
  // location: Yup.array()
  //   .required("Atleast one Location required")
  //   .min(1, "Atleast one Location required"),
  ethnicity: Yup.string().required("Ethnicity required"),
});

export const initialFormValues = {
  phoneNumber: "",
  age: "",
  gender: "",
  language: [],
  experience: "",
  currencyCode: "",
  expectedCurrencyCode: "",
  currentCTC: "",
  expectedCTC: "",
  location: [],
  ethnicity: "",
  isTotalExperience: false,
  isWFH: false,
  isPreferedLocation: false,
};
